export enum Launch_Relax_Skywind {
  "PT" = "PT",
  "ES" = "ES",
  "HU" = "HU",
}
